import "./GlobalFooter.scss";

import React from "react";

import { Container } from "@mui/material";

import {
  FeatureToggle,
  PhGlobalFooterNav
} from "../../models/app-data-model";
import FooterQuickLinks from "../footer-quick-links/FooterQuickLinks";
import GlobalFooterSocialMedia from "../global-footer-social-media/GlobalFooterSocialMedia";
import RichTextBlock from "../rich-text-block/RichTextBlock";

export type GlobalFooterProps = {
  phGlobalFooterNav: PhGlobalFooterNav;
  featureToggles: FeatureToggle[];
};

const GlobalFooter: React.FC<GlobalFooterProps> = ({ phGlobalFooterNav }) => {
  const quickLinks = phGlobalFooterNav?.footer_navigation_group?.quick_link_column;
  const socialMedia = phGlobalFooterNav?.social_media_links;

  const quickLinksData = quickLinks && quickLinks.map((columnData, index) => <FooterQuickLinks quickLinkColumn={columnData} key={index} />);
  const socialMediaData = socialMedia && socialMedia.map((media, index) => <GlobalFooterSocialMedia href={media.reference[0].url} key={index} aria-label={media.alt_text} alt_text={media.alt_text} svg_icon={media.svg_icon}></GlobalFooterSocialMedia>)

  return (
    <footer className='site-footer'>
      <div className='site-footer-content'>
        <Container className='site-footer-quicklinks'>
          {quickLinksData}
        </Container>
        <Container className='site-footer-social'>
          <ul className='site-footer-social-wrapper'>
            {socialMediaData}
          </ul>
        </Container>
        <Container className='site-footer-disclaimers'>
          <RichTextBlock content={phGlobalFooterNav?.footer_rtf} />
        </Container>
      </div>
    </footer>
  );
};

export default GlobalFooter;
